import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, tap, catchError, BehaviorSubject } from 'rxjs';
import { User } from '../models/user';
import { AuthStateService } from './auth-state.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiBaseUrl + 'auth'; // Use environment.apiBaseUrl
  private userEmailSubject = new BehaviorSubject<string | null>(this.getUserEmailFromToken());
  userEmail$ = this.userEmailSubject.asObservable();

  // Add a BehaviorSubject to track auth state changes
  private authStateChanged = new BehaviorSubject<boolean>(false);
  public authStateChanged$ = this.authStateChanged.asObservable();

  private currentUser: any; // Store the current user details

  constructor(
    private http: HttpClient,
    private authStateService: AuthStateService
  ) {}

  login(email: string, password: string): Observable<any> {
    console.log('apiBaseUrl ->', environment.apiBaseUrl);
    return this.http.post(`${this.apiUrl}/login`, { email, password }).pipe(
      tap((response: any) => {
        if (response.token) {
          localStorage.setItem('authToken', response.token);
          // Always remove previous user before setting new one
          localStorage.removeItem('currentUser');
          if (response.user) {
            localStorage.setItem('currentUser', JSON.stringify(response.user));
          }
          // Notify subscribers that auth state has changed
          this.authStateChanged.next(true);
          // Notify that auth state has changed
          this.authStateService.notifyAuthChange();
        }
      }),
      catchError((error) => {
        console.error('Login error:', error); // Log the error
        if (error.status === 0) {
          alert('Unable to connect to the server. Please ensure the backend is running.');
        }
        throw error;
      })
    );
  }

  getCurrentUser(): User | null {
    const userJson = localStorage.getItem('currentUser');
    if (!userJson) return null;
    try {
      return JSON.parse(userJson) as User;
    } catch {
      return null;
    }
  }

  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('currentUser');
    this.userEmailSubject.next(null); // Clear email
    // Notify subscribers that auth state has changed
    this.authStateChanged.next(false);
    // Notify that auth state has changed
    this.authStateService.notifyAuthChange();
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem('authToken'); // Check if the auth token exists
  }

  private getUserEmailFromToken(): string | null {
    const token = localStorage.getItem('authToken');
    if (!token) return null;

    // Decode the token to extract the email (assuming JWT structure)
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.email || null;
  }

  isCurrentUserAdmin(): boolean {
    const token = localStorage.getItem('authToken');
    if (!token) return false;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      // Accept both boolean and string 'true'/'True'
      return payload.isAdministrator === true || payload.isAdministrator === 'true' || payload.isAdministrator === 'True' || payload.isAdministrator === 1;
    } catch {
      return false;
    }
  }

  getUserEmail(): string | null {
    const token = localStorage.getItem('authToken');
    if (!token) return null;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.email || null;
    } catch {
      return null;
    }
  }
}
